import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { withStateHandlers } from 'recompose';

import JobEditor from './JobEditor';
import { getJobFormState, FORM_NAME } from './JobForm';

export const jobEditorModalPropTypes = {
  showJobEditorModal: PropTypes.bool.isRequired,
  jobEditorErrors: PropTypes.array,
  openJobEditorModal: PropTypes.func.isRequired,
  closeJobEditorModal: PropTypes.func.isRequired,
  setJobEditorModalError: PropTypes.func.isRequired,
};

/* eslint-disable react/forbid-prop-types, react/require-default-props */
const propTypes = {
  jobId: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  showJobEditorModal: PropTypes.bool.isRequired,
  jobEditorErrors: PropTypes.array,
  closeJobEditorModal: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
};

export const withModalState = withStateHandlers(
  (props) => {
    return {
      showJobEditorModal: false,
      jobEditorErrors: null,
    };
  },
  {
    openJobEditorModal: (state, props) => {
      return () => {
        return {
          showJobEditorModal: true,
          jobEditorErrors: null,
        };
      };
    },
    closeJobEditorModal: (state, props) => {
      return () => {
        return {
          showJobEditorModal: false,
          jobEditorErrors: null,
        };
      };
    },
    setJobEditorModalError: (state, props, payload) => {
      return (errors) => {
        return {
          jobEditorErrors: errors,
        };
      };
    },
  },
);

const JobEditorModal = (props) => {
  const {
    showJobEditorModal,
    jobEditorErrors,
    closeJobEditorModal,
    onSubmit,
    jobId,
    dispatch,
    formState,
  } = props;

  const { invalid } = formState;
  const hasError = jobEditorErrors !== null && jobEditorErrors !== undefined;
  const errorMessages = (message, index) => {
    return (
      <div key={index}>
        {message}
      </div>
    );
  };

  return (
    <Modal show={showJobEditorModal} onHide={closeJobEditorModal}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Job</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <JobEditor
          jobId={jobId}
          onSubmit={onSubmit}
          onCancel={closeJobEditorModal}
        />
        {hasError && <strong className="text-danger">{jobEditorErrors.map(errorMessages, this)}</strong>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="warning"
          onClick={closeJobEditorModal}
        >Cancel
        </Button>
        <Button
          disabled={invalid}
          bsStyle="primary"
          onClick={() => { return dispatch(submit(FORM_NAME)); }}
        >Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    formState: getJobFormState(state),
  };
};

JobEditorModal.propTypes = propTypes;

export default connect(mapStateToProps)(JobEditorModal);
